import { Navigate, Outlet, RouteObject } from "react-router-dom";
import AndpcRoute from "./andpc";
import FifplRoute from "./fifpl";

const BillingRoute: RouteObject = {
    path: "facturation",
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <Navigate to="/facturation/andpc" replace />
        },
        AndpcRoute,
        FifplRoute
    ]
};
export default BillingRoute;
